import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
    selector: '[appAutoFocus]',
    standalone: false
})
export class AutoFocusDirective implements OnInit {
  @Input() doFocus : boolean | undefined;
  constructor(private elRef: ElementRef) { }

  ngOnInit(): void {
    if (this.doFocus === undefined || this.doFocus) {
      this.elRef.nativeElement.focus();
    }
  }

}
